import { IAugmentedJQuery, IComponentOptions, IController, IDocumentService, INgModelController, IScope, ITimeoutService } from 'angular';
import './check-dropdown-select.component.scss';

export class CheckDropdownSelectCtrl implements IController {
  static $inject = [
    '$element',
    '$timeout',
    '$document',
    '$scope'
  ];
  selectType: 'all' | 'mixed' | 'none';
  isOpened: boolean = false;
  onCheck: (obj: any) => void;
  checked: boolean = false;
  deselect: boolean;

  constructor( private $element: IAugmentedJQuery,
               private $timeout: ITimeoutService,
               private $document: IDocumentService,
               private $scope: IScope ) {
    this.onDocumentClick = this.onDocumentClick.bind(this);
  }

  $onInit() {
    this.$document.on('click', this.onDocumentClick);
    this.$scope.$watch('$ctrl.deselect', (value) => {
      if (!value) {
        this.checked = false;
      }
    });
  }

  $onDestroy() {
    this.$document.off('click', this.onDocumentClick);
  }

  toggleOpen() {
    this.isOpened = !this.isOpened;
  }

  toggleCheck() {
    this.checked = !this.checked;
  }

  isChecked() {
    this.onCheck({checked: this.checked});
  }

  get indeterminate(): boolean {
    return this.selectType === 'mixed';
  }

  private onDocumentClick( event ) {
    if ( this.isOpened && this.$element.has(event.target).length === 0 ) {
      this.$timeout(() => {
        this.isOpened = false;
      });
    }
  }
}

export const CheckDropdownSelectComponent: IComponentOptions = {
  controller: CheckDropdownSelectCtrl,
  template: require('./check-dropdown-select.component.html'),
  // transclude: true,
  bindings: {
    selectType: '<?',
    deselect: '<',
    onCheck: '&'
  }
};



// WEBPACK FOOTER //
// ./app/ui/check-dropdown-select/check-dropdown-select.component.ts